import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

export type LatestPost = {
  id: number;
  rss_title: string;
  domain_name?: string;
  image_url?: string;
  post_status?: string;
  enable_repeat?: number;
  parent_post_id?: number;
  tag?: string;
  social_platform_title?: string;
  scheduled_for?: string | Date;
  rss_description?: string;
};

@Component({
  selector: 'app-latest-posts',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
  ],
  templateUrl: './latest-posts.component.html',
})
export class LatestPostsComponent {
  @Input() posts: LatestPost[] = [];
  @Input() maxSidebarCards = 3;
  @Input() naPlaceholder = './assets/images/na.png';
  @Input() title = 'Latest posts';

  @Output() viewPost = new EventEmitter<LatestPost>();

  get visiblePosts(): LatestPost[] {
    return (this.posts || []).slice(0, this.maxSidebarCards);
  }

  trackById = (_: number, item: LatestPost): number => item.id;

  onViewPost(post: LatestPost): void {
    this.viewPost.emit(post);
  }

  onMainImgError(ev: Event): void {
    const img = ev.target as HTMLImageElement;

    if (!img || img.src.endsWith(this.naPlaceholder)) {
      return;
    }

    img.src = this.naPlaceholder;
  }

  platformTextClass(plat?: string): string {
    const t = (plat || '').toLowerCase().trim();

    switch (t) {
      case 'instagram':
        return 'text-fuchsia-600';

      case 'facebook':
        return 'text-blue-600';

      case 'x':
        return 'text-neutral-700';

      case 'youtube':
        return 'text-red-600';

      default:
        return 'text-gray-700';
    }
  }
}